export const chinaPrescription =
    {
        panels: [
            {
                index: 0,
                paperType: "A5",
                height: 148,
                width: 210,
                paperHeader: 579,
                paperFooter: 419.52755905511816,
                printElements: [
                    {
                        options: {
                            left: 480,
                            top: 1.5,
                            height: 22.5,
                            width: 103.5,
                            borderWidth: "1.5",
                            borderStyle: "solid"
                        },
                        printElementType: {
                            type: "rect"
                        }
                    },
                    {
                        options: {
                            left: 480,
                            top: 3,
                            height: 21,
                            width: 102,
                            title: "中药",
                            fontSize: 16.5,
                            textAlign: "center",
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 169.5,
                            top: 4.5,
                            height: 21,
                            width: 255,
                            fontSize: 18.75,
                            textAlign: "center",
                            textContentVerticalAlign: "middle",
                            field: "clinicPrescriptionName"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 9,
                            height: 16.5,
                            width: 67.5,
                            fontSize: 9,
                            textContentVerticalAlign: "middle",
                            field: "isGrowUp",
                            testData: "成人"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 25.5,
                            height: 19.5,
                            width: 115.5,
                            title: "健康ID",
                            textContentVerticalAlign: "middle",
                            field: "patId"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 192,
                            top: 33,
                            height: 25.5,
                            width: 171,
                            title: "中药处方笺",
                            fontSize: 15,
                            textAlign: "center",
                            lineHeight: 20.25
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 46.5,
                            height: 19.5,
                            width: 120,
                            title: "费别",
                            field: "prhCostType",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 399,
                            top: 46.5,
                            height: 19.5,
                            width: 160.5,
                            title: "编号",
                            field: "code",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 67.5,
                            height: 21,
                            width: 120,
                            title: "姓名",
                            field: "name",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 289.5,
                            top: 67.5,
                            height: 21,
                            width: 90,
                            title: "年龄",
                            field: "age",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 399,
                            top: 67.5,
                            height: 21,
                            width: 160.5,
                            title: "科室",
                            field: "dept",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 174,
                            top: 67.5,
                            height: 21,
                            width: 90,
                            title: "性别",
                            field: "sex",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 90,
                            height: 19.5,
                            width: 120,
                            title: "门诊(住院)号",
                            field: "seedoctorId",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 399,
                            top: 90,
                            height: 18,
                            width: 160.5,
                            title: "日期",
                            field: "date",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 111,
                            height: 16.5,
                            width: 531,
                            title: "住址(单位)",
                            field: "address",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 129,
                            height: 9,
                            width: 531,
                            borderWidth: "1.5"
                        },
                        printElementType: {
                            type: "hline"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 132,
                            height: 19.5,
                            width: 531,
                            title: "临床诊断",
                            field: "westernDiagnos",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 154.5,
                            height: 19.5,
                            width: 531,
                            title: "备注",
                            field: "remake",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 175.5,
                            height: 9,
                            width: 531,
                            borderWidth: "1.5"
                        },
                        printElementType: {
                            type: "hline"
                        }
                    },
                    {
                        options: {
                            left: 121.5,
                            top: 183,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine2"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 214.5,
                            top: 183,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine3"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 307.5,
                            top: 183,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine4"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 183,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine1"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 213,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine7"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 483,
                            top: 183,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine6"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 121.5,
                            top: 213,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine8"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 394.5,
                            top: 183,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine5"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 394.5,
                            top: 213,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine11"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 307.5,
                            top: 213,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine10"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 483,
                            top: 213,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine12"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 214.5,
                            top: 213,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine9"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 121.5,
                            top: 243,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine14"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 214.5,
                            top: 243,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine15"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 307.5,
                            top: 241.5,
                            height: 22.5,
                            width: 78,
                            field: "chineseMedicine16"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 243,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine13"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 483,
                            top: 241.5,
                            height: 22.5,
                            width: 76.5,
                            field: "chineseMedicine18"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 271.5,
                            height: 22.5,
                            width: 78,
                            field: "chineseMedicine19"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 121.5,
                            top: 271.5,
                            height: 22.5,
                            width: 78,
                            field: "chineseMedicine20"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 394.5,
                            top: 241.5,
                            height: 22.5,
                            width: 76.5,
                            field: "chineseMedicine17"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 307.5,
                            top: 271.5,
                            height: 22.5,
                            width: 78,
                            field: "chineseMedicine22"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 394.5,
                            top: 271.5,
                            height: 22.5,
                            width: 76.5,
                            field: "chineseMedicine23"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 214.5,
                            top: 271.5,
                            height: 22.5,
                            width: 78,
                            field: "chineseMedicine21"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 483,
                            top: 271.5,
                            height: 22.5,
                            width: 76.5,
                            field: "chineseMedicine24"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 27,
                            top: 367.5,
                            height: 9,
                            width: 532.5,
                            borderStyle: "dotted"
                        },
                        printElementType: {
                            type: "hline"
                        }
                    },
                    {
                        options: {
                            left: 255,
                            top: 370.5,
                            height: 18,
                            width: 120,
                            title: "调配医师/士",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 418.5,
                            top: 370.5,
                            height: 18,
                            width: 120,
                            title: "核对、发药医师",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 57,
                            top: 370.5,
                            height: 18,
                            width: 120,
                            title: "审核医师",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 58.5,
                            top: 394.5,
                            height: 18,
                            width: 120,
                            title: "处方金额",
                            field: "prescriptionAmount",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 255,
                            top: 396,
                            height: 18,
                            width: 120,
                            title: "取药科室",
                            field: "phayId",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 418.5,
                            top: 396,
                            height: 18,
                            width: 120,
                            title: "医师",
                            field: "doctor",
                            fontSize: 9,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 301.5,
                            height: 22.5,
                            width: 78,
                            field: "chineseMedicine25"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 121.5,
                            top: 301.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine26"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 214.5,
                            top: 301.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine27"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 307.5,
                            top: 301.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine28"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 394.5,
                            top: 301.5,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine29"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 483,
                            top: 301.5,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine30"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 28.5,
                            top: 331.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine31"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 121.5,
                            top: 331.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine32"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 214.5,
                            top: 331.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine33"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 307.5,
                            top: 331.5,
                            height: 21,
                            width: 78,
                            field: "chineseMedicine34"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 394.5,
                            top: 331.5,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine35"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 483,
                            top: 331.5,
                            height: 21,
                            width: 76.5,
                            field: "chineseMedicine36"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                    {
                        options: {
                            left: 510,
                            top: 350,  // 调整到合适的位置，在367.5的虚线上面
                            height: 19.5,
                            width: 100,
                            title: "付数",
                            field: "zyfs",
                            fontSize: 16,
                            textContentVerticalAlign: "middle"
                        },
                        printElementType: {
                            type: "text"
                        }
                    },
                ],
                paperNumberLeft: 481.5,
                paperNumberTop: 456
            }
        ]

    }